module.exports = "<div class=\"loader-admin d-flex justify-content-center align-items-center\">\n  <div class=\"sk-rotating-plane\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/loader-admin/loader-admin.component.html
// module id = ../../../../../src/app/components/loader-admin/loader-admin.component.html
// module chunks = main